(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sola-galo-subscribe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWatchSubscribe(section) {
      if (!section || section.dataset.wsInitialized === 'true') return;
      section.dataset.wsInitialized = 'true';

      var form = section.querySelector('.watch-subscribe__form');
      var button = section.querySelector('.watch-subscribe__button');
      var modal = section.querySelector('[data-ws-modal]');
      var loader = section.querySelector('[data-ws-loader]');
      var backButton = section.querySelector('.watch-subscribe__back');
      var continueButton = section.querySelector('[data-ws-modal-continue]');
      var successMarker = section.querySelector('[data-ws-just-subscribed]');
      var tagsInput = section.querySelector('[data-ws-tags-input]');
      var lastFocused = null;

      // ---- Append URL-based tags (e.g. ?source=sold-out) to contact[tags] ----
      // Lets us trace where the lead came from (sold-out modal, social ad, etc.).
      // Reads `source` from the URL query string, sanitizes it to alphanumeric +
      // hyphen (security against tag injection), and appends to the existing tag.
      // Result: customer gets tagged with BOTH the watch tag AND the source tag.
      if (tagsInput) {
        try {
          var urlParams = new URLSearchParams(window.location.search);
          var sourceParam = urlParams.get('source');
          if (sourceParam) {
            var sanitized = sourceParam.replace(/[^a-z0-9-]/gi, '').toLowerCase().substring(0, 40);
            if (sanitized) {
              var currentTags = tagsInput.value || '';
              // Avoid duplicates if user navigates back & forth
              var tagAlreadyPresent = currentTags
                .split(',')
                .map(function (t) { return t.trim().toLowerCase(); })
                .indexOf(sanitized) !== -1;
              if (!tagAlreadyPresent) {
                tagsInput.value = currentTags
                  ? currentTags + ', ' + sanitized
                  : sanitized;
              }
            }
          }
        } catch (e) {
          /* URLSearchParams unavailable or other failure — fail silently */
        }
      }

      // ---- Storage key for the referrer (the page the lead came from) ----
      // We save it BEFORE submitting because after Shopify refreshes the page,
      // document.referrer points to this subscribe page itself — useless.
      var REFERRER_KEY = 'ws-return-url';
      var fallbackUrl =
        (backButton && backButton.dataset.fallbackUrl) ||
        (continueButton && continueButton.dataset.fallbackUrl) ||
        '/';

      function getReturnUrl() {
        var saved = null;
        try {
          saved = window.sessionStorage.getItem(REFERRER_KEY);
        } catch (e) {
          /* sessionStorage may be blocked — ignore */
        }
        // Validate it's same-origin (security) and not the subscribe page itself
        if (saved) {
          try {
            var url = new URL(saved);
            if (
              url.origin === window.location.origin &&
              url.pathname !== window.location.pathname
            ) {
              return saved;
            }
          } catch (e) {
            /* malformed URL — fall through */
          }
        }
        return fallbackUrl;
      }

      // ---- On submit: save the referrer, show loader, let form submit natively ----
      // We do NOT preventDefault. The browser submits the form to Shopify,
      // Shopify processes it (creating the customer + tag), then redirects
      // back to this page with `?customer_posted=true`. On that reload, the
      // server-side check for form.posted_successfully? renders the success
      // marker, which the load-time check below detects to open the modal.
      //
      // NOTA (SOLA): a tag Liquid condicional foi reescrita por extenso aqui
      // de propósito. Este bloco está dentro de {% javascript %}, que o
      // Shopify NÃO processa como Liquid — a tag literal era inofensiva em
      // runtime, mas o parser do `shopify theme check` não sabe disso e
      // acusava LiquidHTMLSyntaxError (falso positivo) por enxergar um
      // condicional sem fechamento. Manter a redação sem chaves deixa o
      // theme check limpo sem mudar comportamento algum.
      if (form && button) {
        form.addEventListener('submit', function () {
          // Guard against double submit
          if (form.dataset.wsSubmitting === 'true') return;
          form.dataset.wsSubmitting = 'true';

          // Save the page the lead came from BEFORE the form refresh kills
          // document.referrer. Both the modal "Continue Browsing" button and
          // the "Back to Store" button (rendered after success) will use this.
          try {
            if (
              document.referrer &&
              new URL(document.referrer).origin === window.location.origin
            ) {
              window.sessionStorage.setItem(REFERRER_KEY, document.referrer);
            }
          } catch (e) {
            /* sessionStorage blocked or malformed referrer — ignore */
          }

          button.classList.add('is-loading');
          button.disabled = true;

          if (loader) {
            loader.hidden = false;
            loader.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        });
      }

      // ---- Modal controls ----
      function openModal() {
        if (!modal) return;
        lastFocused = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        setTimeout(function () {
          var firstButton = modal.querySelector('.watch-subscribe__modal-button');
          if (firstButton) firstButton.focus();
        }, 100);
      }

      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      if (modal) {
        // X button and backdrop click → just close, don't navigate
        var closers = modal.querySelectorAll('[data-ws-modal-close]');
        for (var i = 0; i < closers.length; i++) {
          closers[i].addEventListener('click', closeModal);
        }
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) {
            closeModal();
          }
        });
      }

      // ---- "Continue Browsing" button → navigate back to the watch page ----
      if (continueButton) {
        continueButton.addEventListener('click', function () {
          window.location.href = getReturnUrl();
        });
      }

      // ---- "Back to Store" button → same destination as Continue Browsing ----
      // Only renders when form.posted_successfully? is true (server-side).
      if (backButton) {
        backButton.addEventListener('click', function () {
          window.location.href = getReturnUrl();
        });
      }

      // ---- On page load: if Shopify just posted the form successfully,
      //      reveal the back button + open the modal after a small delay. ----
      if (successMarker) {
        // Reveal the back button immediately (no animation needed)
        if (backButton) {
          backButton.hidden = false;
        }

        if (modal) {
          setTimeout(function () {
            openModal();

            // Clean URL so a refresh (F5) doesn't re-trigger the modal
            if (window.history && window.history.replaceState) {
              try {
                var url = new URL(window.location.href);
                url.searchParams.delete('customer_posted');
                url.searchParams.delete('contact_posted');
                window.history.replaceState(
                  {},
                  document.title,
                  url.pathname + url.search + url.hash
                );
              } catch (err) {
                /* old browsers — ignore */
              }
            }
          }, 350);
        }
      }
    }

    // Init existing sections on the page
    var sections = document.querySelectorAll('.watch-subscribe');
    for (var i = 0; i < sections.length; i++) {
      initWatchSubscribe(sections[i]);
    }

    // Init dynamically added sections (Shopify theme editor live preview)
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.watch-subscribe');
      if (section) initWatchSubscribe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
